// Explicit content word list - matches database validation
// This prevents users from posting inappropriate content
const profanityList = [
  'fuck', 'fucking', 'fucked', 'fucker',
  'shit', 'shitting', 'shitty',
  'ass', 'asshole', 'asses',
  'bitch', 'bitches', 'bitching',
  'cunt', 'cunts',
  'dick', 'dicks',
  'pussy', 'pussies',
  'cock', 'cocks',
  'whore', 'whores',
  'slut', 'sluts', 'slutty',
  'bastard', 'bastards',
  'damn', 'damned',
  'crap', 'crappy',
  'piss', 'pissed', 'pissing',
  'wank', 'wanker',
  'twat', 'twats',
  'bollocks',
  'bullshit',
  'fag', 'faggot', 'fags',
  'nigger', 'nigga',
  'retard', 'retarded',
  'rape', 'raping', 'raped',
  'sex', 'sexual', 'sexy',
  'porn', 'porno', 'pornography',
  'xxx',
  'anal',
  'cum', 'cumming',
  'jizz',
  'tit', 'tits', 'titty',
  'boob', 'boobs', 'booby',
  'dildo',
  'viagra',
  'penis',
  'vagina',
  'blowjob',
  'handjob',
  'nude', 'nudes', 'naked',
  'escort', 'escorts',
  'hookup', 'hookups',
  'horny',
  // Suggestive words with double meanings (blocked for safety)
  'doggy', 'doggie',
  'daddy',
  'spank', 'spanking', 'spanked',
  'kinky', 'kink',
  'fetish',
  'naughty',
  'mistress',
  'submissive', 'dominant', 'domme',
  'bdsm',
  'erotic',
  'seduce', 'seducing', 'seduction',
  'flirt', 'flirty', 'flirting',
  'tease', 'teasing',
  'sext', 'sexting',
  'bang', 'banging',
  'smash',
  'breed', 'breeding'
];

/**
 * Filters profanity from text by replacing it with asterisks
 * @param text The text to filter
 * @returns Filtered text with profanity replaced by asterisks
 */
export const filterProfanity = (text: string): string => {
  if (!text) return text;
  
  let filteredText = text;
  
  // Check for whole words using word boundaries
  profanityList.forEach(word => {
    const regex = new RegExp(`\\b${word}\\b`, 'gi');
    filteredText = filteredText.replace(regex, '*'.repeat(word.length));
  });
  
  return filteredText;
};

/**
 * Checks if text contains profanity
 * @param text The text to check
 * @returns True if profanity is found, false otherwise
 */
export const containsProfanity = (text: string): boolean => {
  if (!text) return false;
  
  return profanityList.some(word => {
    const regex = new RegExp(`\\b${word}\\b`, 'gi');
    return regex.test(text);
  });
};

/**
 * Filters profanity from an object's text fields
 * @param obj Object with string properties to filter
 * @returns New object with filtered text
 */
export const filterObjectProfanity = <T extends Record<string, any>>(obj: T): T => {
  const result = { ...obj };
  
  Object.keys(result).forEach(key => {
    if (typeof result[key] === 'string') {
      result[key] = filterProfanity(result[key]);
    }
  });
  
  return result;
};